// Integration.js
// Purpose: Manages third-party integrations (e.g., Google Search Console, Notion) for the workspace.
// Logic: Uses React hooks and state to handle authentication, display integration status, and manage related modals and forms.

import { useEffect, useState, useRef } from "react";
import { Button, Drawer } from "flowbite-react";
import { Accordion } from "flowbite-react";
import useCommonApi from "../hooks/common-apis";
import SuccessModal from "../components/SuccessModal";
import FailureModal from "../components/FailureModal";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { Tooltip } from "react-tooltip";
import Loader from "../components/Loader";
import { clog, isUserOwnerOfWorkspace } from "../lib/utils";

function IntegrationMarketing() {
  // offcanvas
  const [isOpenGSC, setIsOpenGSC] = useState(false);
  const [gscLoading, setgscLoading] = useState(false);
  const [inputUrlGSC, setInputUrlGSC] = useState("");
  const [isValidGSC, setIsValidGSC] = useState(true);
  const handleChangeGSC = (e) => {
    const inputValue = e.target.value.trim();
    if (inputValue === "") {
      setIsValidGSC(true);
      setInputUrlGSC(inputValue);
      return;
    }
    setInputUrlGSC(inputValue);

    // const urlPattern =
    //   /^(https?:\/\/)?(www\.)?[a-zA-Z0-9][a-zA-Z0-9-]*\.[a-zA-Z]{2,6}(\/.*)?$/;
    const urlPattern = /^(https?:\/\/)?([\w-]+\.)+[a-zA-Z]{2,}(\/.*)?$/;
    setIsValidGSC(urlPattern.test(inputValue));
  };
  const [gsc_website, setGsc_website] = useState(
    localStorage.getItem("gsc_website")
  );
  const [notion_access, setnotion_access] = useState(
    JSON.parse(localStorage.getItem("notion_access") || "false")
  );
  const [notionAccessList, setNotionAccessList] = useState([]);
  const [isOpenNotion, setIsOpenNotion] = useState(false);
  const [notionLoading, setnotionLoading] = useState(false);
  const [inputUrlNotion, setInputUrlNotion] = useState("");
  const [isValidNotion, setIsValidNotion] = useState(true);
  const getNotionAuth = async (url) => {
    if (!isValidNotion || !url) return;

    setnotionLoading(true);

    try {
      const response = await axios({
        url: `${process.env.REACT_APP_BASE_SIGNIN_URL}/notion/authurl`,
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          jwt_token: localStorage.getItem("login_token"),
        },
        // data: {
        //   // domain: url,
        // },
      });
      if (!response.data.error && response.data.url) {
        // setsuccessFailureMessage(response.data.message);
        // setopenSuccessModal("dismissible");
        // setwordPressDetails(response?.data?.data);
        // setUrls([url]);
        // setInputUrl("");
        // localStorage.setItem("gsc_website",url);
        // gsc_website = inputUrlGSC;
        window.open(response.data.url, "_self");
      } else {
        setopenFailureModal("dismissible");
        setsuccessFailureMessage(
          response.data.message || "Something went wrong"
        );
        // setwordPressDetails({});
      }
    } catch (error) {
      clog(error);
      if (error.response && error?.response?.status == 401) {
        localStorage.removeItem("login_token");
        localStorage.removeItem("login_data");
        navigate("/");
      }
    } finally {
      setnotionLoading(false);
    }
  };
  async function checkNotionAccess() {
    try {
      setnotionLoading(true);
      let response = await axios({
        url: `${process.env.REACT_APP_BASE_SIGNIN_URL}/api/notion/access`,
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          jwt_token: localStorage.getItem("login_token"),
        },
        params: {
          user_id: JSON.parse(localStorage.getItem("login_data"))?.resp_user
            ?.id,
        },
      });
      // clog(response, "response");
      if (!response.data.error) {
        if (response.data?.access_token) {
          localStorage.setItem("notion_access", JSON.stringify(true));
          setnotion_access(true);
          setNotionAccessList(response.data?.data);
        } else {
          localStorage.setItem("notion_access", JSON.stringify(false));
          setnotion_access(false);
          setNotionAccessList([]);
        }
      } else {
        localStorage.setItem("notion_access", JSON.stringify(false));
        setnotion_access(false);
        setNotionAccessList([]);
      }
    } catch (error) {
      clog(error);
      if (error.response && error?.response?.status == 401) {
        localStorage.removeItem("login_token");
        localStorage.removeItem("login_data");
        navigate("/");
      }
      localStorage.setItem("notion_access", JSON.stringify(false));
      setnotion_access(false);
      setNotionAccessList([]);
    } finally {
      setnotionLoading(false);
    }
  }
  async function checkGscAccess() {
    try {
      let response = await axios({
        url: `${process.env.REACT_APP_BASE_SIGNIN_URL}/api/google/search/website`,
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          jwt_token: localStorage.getItem("login_token"),
        },
        params: {
          user_id: JSON.parse(localStorage.getItem("login_data"))?.resp_user
            ?.id,
        },
      });
      // clog(response, "response");
      if (!response.data.error) {
        if (response.data?.data?.access_token) {
          localStorage.setItem(
            "google_search_console_access",
            JSON.stringify(response.data?.data)
          );
          setGsc_website(response.data?.data?.profile_url);
          localStorage.setItem("gsc_website", response.data?.data?.profile_url);
        } else {
          localStorage.removeItem("google_search_console_access");
          setGsc_website(null);
          localStorage.removeItem("gsc_website");
        }
      } else {
        localStorage.removeItem("google_search_console_access");
        setGsc_website(null);
        localStorage.removeItem("gsc_website");
      }
    } catch (error) {
      clog(error);
      if (error.response && error?.response?.status == 401) {
        localStorage.removeItem("login_token");
        localStorage.removeItem("login_data");
        navigate("/");
      }
      localStorage.removeItem("google_search_console_access");
      setGsc_website(null);
      localStorage.removeItem("gsc_website");
    }
  }
  const [isOpen, setIsOpen] = useState(false);
  const [wordpressLoading, setwordpressLoading] = useState(false);
  const [wordpressLoadingRegenrate, setwordpressLoadingRegenrate] =
    useState(false);
  const [deleteUrl, setdeleteUrl] = useState(false);
  const navigate = useNavigate();

  const handleClose = () => setIsOpen(false);
  // offcanvas
  const [openModal, setOpenModal] = useState();
  const [twitterProfile, setTwitterProfile] = useState(null);
  const [checking, setChecking] = useState(false);
  const [openSuccessModal, setopenSuccessModal] = useState(undefined);
  const [openFailureModal, setopenFailureModal] = useState(undefined);
  const [successFailureMessage, setsuccessFailureMessage] = useState("");
  const [wordPressDetails, setwordPressDetails] = useState({});
  const removeModal = () => {
    setopenSuccessModal(undefined);
    setopenFailureModal(undefined);
  };
  const { checkTwitterAccess } = useCommonApi();
  let login_data = JSON.parse(localStorage.getItem("login_data"));
  async function handleTwitterLogin() {
    try {
      // clog(
      //   `${process.env.REACT_APP_BASE_SIGNIN_URL}/auth/twitter/${
      //     login_data?.resp_user?.id
      //   }?redirect_uri=${window.location.origin + window.location.pathname}`,
      //   "_self",
      //   "FULL URL"
      // );
      // return;
      window.open(
        `${process.env.REACT_APP_BASE_USER_URL}/auth/twitter/${
          login_data?.resp_user?.id
        }?redirect_uri=${window.location.origin + window.location.pathname}`,
        "_self"
      );
    } catch (error) {
      console.error("Error initiating Twitter login", error);
    }
  }
  const integrateLinkedIn = async () => {
    // clog(id);
    try {
      const response = await axios({
        url: `${process.env.REACT_APP_BASE_SIGNIN_URL}/linkedin/auth`,
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          jwt_token: localStorage.getItem("login_token"),
        },
      });
      if (!response.data.error) {
        localStorage.setItem("linkedin_navigation", "/integration-marketing");
        window.open(response.data.url, "_self");
      } else {
      }
    } catch (error) {
      clog(error);
      if (error.response && error?.response?.status == 401) {
        localStorage.removeItem("login_token");
        localStorage.removeItem("login_data");
        navigate("/");
      }
    }
  };
  const getWordPressAuth = async (url, from) => {
    if (!isValid || !url) return;
    if (from === "regenerate") {
      setwordpressLoadingRegenrate(true);
    } else {
      setwordpressLoading(true);
    }
    try {
      const response = await axios({
        url: `${process.env.REACT_APP_BASE_SIGNIN_URL}/api/wordpress/integration`,
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          jwt_token: localStorage.getItem("login_token"),
        },
        data: {
          domain: url,
        },
      });
      if (!response.data.error) {
        setsuccessFailureMessage(response.data.message);
        setopenSuccessModal("dismissible");
        setwordPressDetails(response?.data?.data);
        setUrls([url]);
        setInputUrl("");
      } else {
        setopenFailureModal("dismissible");
        setsuccessFailureMessage(response.data.message);
        setwordPressDetails({});
      }
    } catch (error) {
      clog(error);
      if (error.response && error?.response?.status == 401) {
        localStorage.removeItem("login_token");
        localStorage.removeItem("login_data");
        navigate("/");
      }
    } finally {
      setwordpressLoading(false);
      setwordpressLoadingRegenrate(false);
    }
  };
  const getGSCAuth = async (url) => {
    if (!isValidGSC || !url) return;

    setgscLoading(true);

    try {
      const response = await axios({
        url: `${process.env.REACT_APP_BASE_SIGNIN_URL}/googleapi/authurl`,
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          jwt_token: localStorage.getItem("login_token"),
        },
        data: {
          // domain: url,
        },
      });
      if (!response.data.error && response.data.authUrl) {
        // setsuccessFailureMessage(response.data.message);
        // setopenSuccessModal("dismissible");
        // setwordPressDetails(response?.data?.data);
        // setUrls([url]);
        // setInputUrl("");
        localStorage.setItem("gsc_website", url);
        // gsc_website = inputUrlGSC;
        setGsc_website(inputUrlGSC);
        window.open(response.data.authUrl, "_self");
      } else {
        setopenFailureModal("dismissible");
        setsuccessFailureMessage(
          response.data.message || "Something went wrong"
        );
        // setwordPressDetails({});
      }
    } catch (error) {
      clog(error);
      if (error.response && error?.response?.status == 401) {
        localStorage.removeItem("login_token");
        localStorage.removeItem("login_data");
        navigate("/");
      }
    } finally {
      setgscLoading(false);
    }
  };
  const deleteWordPressAuth = async () => {
    setdeleteUrl(true);
    try {
      const response = await axios({
        url: `${process.env.REACT_APP_BASE_SIGNIN_URL}/api/wordpress/integration-marketing`,
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          jwt_token: localStorage.getItem("login_token"),
        },
        data: {
          // domain: url,
        },
      });
      if (!response.data.error) {
        setsuccessFailureMessage(response.data.message);
        setopenSuccessModal("dismissible");
        setUrls([]);
        setInputUrl("");
        setwordPressDetails({});
      } else {
        setopenFailureModal("dismissible");
        setsuccessFailureMessage(response.data.message);
      }
    } catch (error) {
      clog(error);
      if (error.response && error?.response?.status == 401) {
        localStorage.removeItem("login_token");
        localStorage.removeItem("login_data");
        navigate("/");
      }
    } finally {
      setdeleteUrl(false);
    }
  };
  const getWordPressPixel = async () => {
    // clog(id);
    try {
      const response = await axios({
        url: `${process.env.REACT_APP_BASE_SIGNIN_URL}/api/cms/getaccessdata/wordpress`,
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          jwt_token: localStorage.getItem("login_token"),
        },
      });
      if (!response.data.error) {
        setwordPressDetails({ ...response?.data?.data[0] });
        if (response?.data?.data[0]?.domain) {
          setUrls([response?.data?.data[0]?.domain]);
        }
      } else {
      }
    } catch (error) {
      clog(error);
      if (error.response && error?.response?.status == 401) {
        localStorage.removeItem("login_token");
        localStorage.removeItem("login_data");
        navigate("/");
      }
    }
  };
  const handleDeleteUrl = (index) => {
    const updatedUrls = urls.filter((_, i) => i !== index);
    setUrls(updatedUrls);
  };
  const getLinkedInAccessToken = async (code) => {
    // clog(id);
    try {
      const response = await axios({
        url: `${process.env.REACT_APP_BASE_SIGNIN_URL}/api/linkedin/access`,
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          jwt_token: localStorage.getItem("login_token"),
        },
      });
      if (!response.data.error) {
        // window.open(response.data.url, "_self");
        localStorage.setItem("linkedin_access", JSON.stringify(response.data));
      } else {
      }
    } catch (error) {
      clog(error);
      if (error.response && error?.response?.status == 401) {
        localStorage.removeItem("login_token");
        localStorage.removeItem("login_data");
        navigate("/");
      }
    } finally {
    }
  };
  const [tooltip, setTooltip] = useState("Copy");
  const [tooltipType, settooltipType] = useState("");
  const [showTooltip, setShowTooltip] = useState(false);
  const textareaRef = useRef(null);
  const textareaRefPixel = useRef(null);
  const [urls, setUrls] = useState([]);
  const [inputUrl, setInputUrl] = useState("");
  const [isValid, setIsValid] = useState(true);
  const handleChange = (e) => {
    const inputValue = e.target.value.trim();
    if (inputValue === "") {
      setIsValid(true);
      setInputUrl(inputValue);
      return;
    }
    setInputUrl(inputValue);

    // const urlPattern =
    //   /^(https?:\/\/)?(www\.)?[a-zA-Z0-9][a-zA-Z0-9-]*\.[a-zA-Z]{2,6}(\/.*)?$/;
    const urlPattern = /^(https?:\/\/)?([\w-]+\.)+[a-zA-Z]{2,}(\/.*)?$/;
    setIsValid(urlPattern.test(inputValue));
  };

  const handleAddUrl = () => {
    if (!isValid) {
      return;
    }
    if (inputUrl.trim() !== "") {
      setUrls([...urls, inputUrl]); // Add new URL to state
      setInputUrl(""); // Clear input after adding
    }
  };

  const handleCopy = (type) => {
    if (textareaRef.current && type === "key") {
      navigator.clipboard.writeText(textareaRef.current.value);
    }
    if (textareaRefPixel.current && type === "pixel") {
      navigator.clipboard.writeText(textareaRefPixel.current.value);
    }
    setTooltip("Copied!");
    setShowTooltip(true);
    settooltipType(type);

    setTimeout(() => {
      setTooltip("Copy");
      setShowTooltip(false);
      settooltipType("");
    }, 2000); // Reset after 2s
  };
  useEffect(() => {
    // Check if user is workspace owner
    if (!isUserOwnerOfWorkspace()) {
      navigate("/unauthorized");
      return;
    }

    if (!twitterProfile) {
      checkTwitterAccess(setTwitterProfile, setChecking);
    }
    const searchParams = new URLSearchParams(window.location.search);
    let success = searchParams.get("success");
    //parse success to bool
    success = success === "true" ? true : false;
    const error = searchParams.get("error");
    //if searchparams are present then update the twitter access token
    if (searchParams.has("success")) {
      if (!success) {
        clog("error from query", error);
        setopenFailureModal("dismissible");
        setsuccessFailureMessage(error);
      }
    }
  }, [twitterProfile]);
  useEffect(() => {
    getWordPressPixel();
    checkNotionAccess();
    checkGscAccess();
    const searchParams = new URLSearchParams(window.location.search);
    let error = searchParams.get("error");
    if (error) {
      setopenFailureModal("dismissible");
      setsuccessFailureMessage(error);
      // remove error from search params after showing error using react router
      setTimeout(() => {
        searchParams.delete("error");
        window.history.replaceState({}, "", `${window.location.pathname}`);
      }, 500);
    }
  }, []);

  return (
    <>
      <h6 className="font-[600] text-[24px]">Marketing</h6>
      <p className="font-[500] text-[16px] pt-3">
        Lorem ipsum dolor sit amet, consectetur adipiscing elit.
      </p>

      <div className="my-[36px] integrationAccordion">
        <Accordion className="w-full mb-4">
          <Accordion.Panel>
            <Accordion.Title className="dark:text-[#000]">
              <div className="flex items-center">
                <svg className="icon me-2 text-[24px]">
                  <use href="#icon_blog_post"></use>
                </svg>
                Blog Post
              </div>
            </Accordion.Title>
            <Accordion.Content className="contentAcco pt-0">
              <hr />
              <div className="pt-3">
                <div class="grid grid-cols-5 gap-4 btnWrapper">
                  <div className="btnBox" onClick={() => setIsOpen(true)}>
                    <div className="leftBox">
                      <div className="imgBox">
                        <img
                          src="images/wp.svg"
                          className="wh-40px"
                          alt="..."
                        />
                      </div>
                    </div>
                    <div className="content">
                      <h6>WordPress</h6>
                      {/* <p>Lorem ipsum dolor sit amet</p> */}
                    </div>
                    <div className="connectBox">
                      <div className="conConnect">
                        {Object.keys(wordPressDetails || {}).length > 0
                          ? "View"
                          : "Connect"}
                      </div>
                    </div>
                    {Object.keys(wordPressDetails || {}).length > 0 && (
                      <span className="checkTick">
                        <svg className="icon">
                          <use href="#icon_green-check"></use>
                        </svg>
                      </span>
                    )}
                  </div>
                  <div className="btnBox">
                    <div className="leftBox">
                      <div className="imgBox">
                        <img
                          src="images/icons8-notion.svg"
                          className="wh-40px"
                          alt="..."
                        />
                      </div>
                    </div>
                    <div className="content">
                      <h6>Notion</h6>
                      {/* <p>Lorem ipsum dolor sit amet</p> */}
                    </div>
                    {/* {!notion_access && ( */}
                    <div
                      className="connectBox"
                      onClick={() => setIsOpenNotion(true)}
                    >
                      <div className="conConnect">
                        {!notion_access ? "Connect" : "View"}
                      </div>
                    </div>
                    {/* )} */}
                    {notion_access && (
                      <span className="checkTick">
                        <svg className="icon">
                          <use href="#icon_green-check"></use>
                        </svg>
                      </span>
                    )}
                  </div>

                  <div className="btnBox">
                    <div className="leftBox">
                      <div className="imgBox">
                        <img
                          src="images/ghost.svg"
                          className="wh-40px"
                          alt="..."
                        />
                      </div>
                    </div>
                    <div className="content">
                      <h6>Ghost</h6>
                      {/* <p>Lorem ipsum dolor sit amet</p> */}
                    </div>
                    {/* <div className="connectBox">
                      <div className="conConnect">Connect</div>
                    </div> */}
                    <div className="comn-soon">Coming Soon</div>
                  </div>

                  <div className="btnBox comText">
                    <div className="leftBox">
                      <div className="imgBox">
                        <img
                          src="images/shopify.svg"
                          className="wh-40px"
                          alt="..."
                        />
                      </div>
                    </div>
                    <div className="content">
                      <h6>Shopify</h6>
                      {/* <p>Lorem ipsum dolor sit amet</p> */}
                    </div>
                    <div className="comn-soon">Coming Soon</div>
                  </div>

                  <div className="btnBox comText">
                    <div className="leftBox">
                      <div className="imgBox">
                        <img src="images/wix.svg" alt="..." />
                      </div>
                    </div>
                    <div className="content">
                      <h6>Wix</h6>
                      {/* <p>Lorem ipsum dolor sit amet</p> */}
                    </div>
                    <div className="comn-soon">Coming Soon</div>
                  </div>

                  <div className="btnBox comText">
                    <div className="leftBox">
                      <div className="imgBox">
                        <img src="images/webflow.svg" alt="..." />
                      </div>
                    </div>
                    <div className="content">
                      <h6>Webflow</h6>
                      {/* <p>Lorem ipsum dolor sit amet</p> */}
                    </div>
                    <div className="comn-soon">Coming Soon</div>
                  </div>
                </div>
              </div>
            </Accordion.Content>
          </Accordion.Panel>
        </Accordion>

        {/* Social Section - Moved to IntegrationSocial.js */}
        {/* <Accordion className="w-full mb-4">
          <Accordion.Panel>
            <Accordion.Title className="dark:text-[#000]">
              <div className="flex items-center">
                <svg className="icon me-2 text-[24px]">
                  <use href="#icon_social_new"></use>
                </svg>
                Social
              </div>
            </Accordion.Title>
            <Accordion.Content className="contentAcco pt-0">
              <hr />
              <div className="pt-3">
                <div class="grid grid-cols-5 gap-4 btnWrapper">
                  <div className="btnBox">
                    <div className="leftBox">
                      <div className="imgBox">
                        <img src="images/x.svg" className="wh-40px" alt="..." />
                      </div>
                    </div>
                    <div className="content">
                      <h6>Twitter</h6>
                    </div>
                    {!twitterProfile && (
                      <div
                        className="connectBox"
                        onClick={() => {
                          if (checking) {
                            return;
                          }
                          if (!twitterProfile) {
                            handleTwitterLogin();
                          }
                        }}
                      >
                        <div className="conConnect">Connect</div>
                      </div>
                    )}
                    {twitterProfile && (
                      <span className="checkTick">
                        <svg className="icon">
                          <use href="#icon_green-check"></use>
                        </svg>
                      </span>
                    )}
                  </div>

                  <div className="btnBox">
                    <div className="leftBox">
                      <div className="imgBox">
                        <img
                          src="images/linkedin.svg"
                          className="wh-40px"
                          alt="..."
                        />
                      </div>
                    </div>
                    <div className="content">
                      <h6>LinkedIn</h6>
                    </div>
                    {!localStorage.getItem("linkedin_access") && (
                      <div
                        className="connectBox"
                        onClick={() => integrateLinkedIn()}
                      >
                        <div className="conConnect">Connect</div>
                      </div>
                    )}
                    {localStorage.getItem("linkedin_access") && (
                      <span className="checkTick">
                        <svg className="icon">
                          <use href="#icon_green-check"></use>
                        </svg>
                      </span>
                    )}
                  </div>
                  <div className="btnBox comText">
                    <div className="leftBox">
                      <div className="imgBox">
                        <img
                          src="images/fb.svg"
                          className="wh-40px"
                          alt="..."
                        />
                      </div>
                    </div>
                    <div className="content">
                      <h6>Facebook</h6>
                    </div>
                    <div className="comn-soon">Coming Soon</div>
                  </div>

                  <div className="btnBox comText">
                    <div className="leftBox">
                      <div className="imgBox">
                        <img
                          src="images/insta.svg"
                          className="wh-40px"
                          alt="..."
                        />
                      </div>
                    </div>
                    <div className="content">
                      <h6>Instagram</h6>
                    </div>
                    <div className="comn-soon">Coming Soon</div>
                  </div>
                </div>
              </div>
            </Accordion.Content>
          </Accordion.Panel>
        </Accordion> */}

        <Accordion className="w-full mb-4">
          <Accordion.Panel>
            <Accordion.Title className="dark:text-[#000]">
              <div className="flex items-center">
                <svg className="icon me-2 text-[24px]">
                  <use href="#icon_social_add"></use>
                </svg>
                Webmaster
              </div>
            </Accordion.Title>
            <Accordion.Content className="contentAcco pt-0">
              <hr />
              <div className="pt-3">
                <div class="grid grid-cols-5 gap-4 btnWrapper">
                  <div className="btnBox">
                    <div className="leftBox">
                      <div className="imgBox">
                        <img
                          src="images/gsc.svg"
                          className="wh-40pxl"
                          alt="..."
                        />
                      </div>
                    </div>
                    <div className="content">
                      <h6>Google Search Console</h6>
                      {/* <p>Lorem ipsum dolor sit amet</p> */}
                    </div>
                    {!localStorage.getItem("google_search_console_access") && (
                      <div
                        className="connectBox"
                        onClick={() => setIsOpenGSC(true)}
                      >
                        <div className="conConnect">Connect</div>
                      </div>
                    )}
                    {localStorage.getItem("google_search_console_access") && (
                      <span className="checkTick">
                        <svg className="icon">
                          <use href="#icon_green-check"></use>
                        </svg>
                      </span>
                    )}
                  </div>

                  <div className="btnBox comText">
                    <div className="leftBox">
                      <div className="imgBox">
                        <img
                          src="images/bing.svg"
                          className="wh-40px"
                          alt="..."
                        />
                      </div>
                    </div>
                    <div className="content">
                      <h6>Bing Webmaster</h6>
                      {/* <p>Lorem ipsum dolor sit amet</p> */}
                    </div>
                    <div className="comn-soon">Coming Soon</div>
                  </div>
                </div>
              </div>
            </Accordion.Content>
          </Accordion.Panel>
        </Accordion>
      </div>

      {/* offcanvas */}
      {/* <div className="flex min-h-[50vh] items-center justify-center">
        <Button onClick={() => setIsOpen(true)}>Show right drawer</Button>
      </div> */}
      <Drawer
        open={isOpen}
        onClose={handleClose}
        position="right"
        className="p-0 w-[42%] notification-canvas add-canvas"
      >
        {/* <Drawer.Header title="Notification" className="pt-3 bg-[#D9F4FF]">kkkk</Drawer.Header> */}
        <div className="px-[28px] py-3 bg-[#D9F4FF] flex">
          <div className="flex items-center">
            <div className="w-[50px] h-[50px] me-4">
              <img
                src="images/wp-black.svg"
                alt="..."
                className="w-full h-full"
              />
            </div>
            <div className="text-[16px] font-[500]">WordPress</div>
          </div>
          <button
            type="button"
            className="ms-auto"
            onClick={() => setIsOpen(false)}
          >
            <svg className="icon text-[28px]">
              <use href="#icon_close"></use>
            </svg>
          </button>
        </div>
        <Drawer.Items className="">
          <div className="px-[28px] flex">
            {/* <div className="w-[60%]">
              <h5 className="py-3 mt-3">Benefits Of Integrating WordPress</h5>
              <h5 className="py-3 mt-3">Integrate WordPress</h5>
              <p className="pb-4">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean
                fringilla placerat libero, viverra facilisis mi lobortis vita
                enim congue lacinia vulputate, diam ex faucibus felis, id
                sollicitudin urna orci eget nunc. Etiam malesuada tincidunt
                ipsum non tristique. Lorem ipsum dolor sit amet, consectetur
                adipiscing elit. Aenean fringilla placerat libero, viverra
                facilisis mi lobortis vita enim congue lacinia vulputate, diam
                ex faucibus felis, id sollicitudin urna orci eget nunc. Etiam
                malesuada tincidunt ipsum non tristique.
              </p>

              <p className="pb-4">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean
                fringilla placerat libero, viverra facilisis mi lobortis vita
                enim congue lacinia vulputate, diam ex faucibus felis, id
                sollicitudin urna orci eget nunc. Etiam malesuada tincidunt
                ipsum non tristique. Lorem ipsum dolor sit amet, consectetur
                adipiscing elit. Aenean fringilla placerat libero, viverra
                facilisis mi lobortis vita enim congue lacinia vulputate, diam
                ex faucibus felis, id sollicitudin urna orci eget nunc. Etiam
                malesuada tincidunt ipsum non tristique.
              </p>

              <ul>
                <li>
                  Lorem ipsum dolor sit amet consectetur adipisicing elit.
                  Officiis fugit dolore.
                </li>
                <li>
                  Lorem ipsum dolor sit amet consectetur adipisicing elit.
                  Officiis fugit dolore.
                </li>
                <li>
                  Lorem ipsum dolor sit amet consectetur adipisicing elit.
                  Officiis fugit dolore.
                </li>
                <li>
                  Lorem ipsum dolor sit amet consectetur adipisicing elit.
                  Officiis fugit dolore.
                </li>
              </ul>
            </div> */}
            <div className="w-full px-5">
              <div className="mt-6">
                <div className="flex items-center mb-3">
                  <h3 className="text-[22px] font-[700]">
                    Restrict website For Added Security
                  </h3>
                </div>
                <div className="flex">
                  <div className="w-full me-3">
                    <input
                      type="text"
                      placeholder="https://www.abc.com"
                      value={inputUrl}
                      onChange={handleChange}
                      className="resize-none px-[20px] rounded-[14px] w-full shadow-md border border-[#E9EBF0]"
                      onKeyDown={(e) => {
                        if (e.key === "Enter") {
                          e.preventDefault();
                        }
                      }}
                    />
                  </div>
                  <button
                    type="button"
                    disabled={!isValid || wordpressLoading || urls?.length > 0}
                    onClick={() => {
                      getWordPressAuth(inputUrl, "add");
                    }}
                    className={`py-2 max-w-[120px] w-full flex justify-center items-center text-center rounded-[20px] text-[18px] font-semibold ring-[1px] ring-[#2A2A2A] ring-[none] bg-gradient-to-r from-[#5E78F4] to-[#F14CE2] text-white hover:transition hover:delay-75 
                      ${
                        !isValid || wordpressLoading || urls?.length > 0
                          ? "opacity-80 cursor-not-allowed"
                          : ""
                      }`}
                  >
                    {wordpressLoading ? <Loader /> : "Add"}
                  </button>
                </div>
                {!isValid && (
                  <p className="text-red-500 pt-2">Please enter a valid URL.</p>
                )}

                <div className="mt-4">
                  <div className="mt-4">
                    {urls.map((url, index) => (
                      <div
                        key={index}
                        className="flex items-center justify- mb-2 p-2  rounded-md"
                      >
                        <a
                          href={url}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="text-[#5E78F4] font-[600] text-[18px] truncate max-w-[85%]"
                        >
                          {url}
                        </a>

                        {/* Delete Button */}
                        <button
                          // onClick={() => handleDeleteUrl(index)}
                          onClick={() => deleteWordPressAuth()}
                          className="ml-2 text-red-500 hover:text-red-700 flex justify-center items-center"
                        >
                          {deleteUrl ? (
                            <Loader />
                          ) : (
                            <svg className="icon w-6 h-6">
                              <use href="#icon_delete"></use>
                            </svg>
                          )}
                        </button>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
              <div className="py-3 mt-4">
                <div>
                  <div className="flex items-center mb-3">
                    <h3 className="text-[22px] font-[700]">Get Website Key</h3>
                    <button
                      type="button"
                      className="ms-auto bg-gradient-to-r flex justify-center items-center from-[#5E78F4] to-[#F14CE2] inline-block text-transparent bg-clip-text font-[600] text-[20px]"
                      onClick={() => {
                        if (Object.keys(wordPressDetails || {})?.length > 0) {
                          getWordPressAuth(
                            wordPressDetails?.domain,
                            "regenerate"
                          );
                        }
                      }}
                    >
                      {wordpressLoadingRegenrate ? (
                        <Loader />
                      ) : (
                        "Click To Regenerate"
                      )}
                    </button>
                  </div>
                  <div className="relative">
                    <textarea
                      ref={textareaRef}
                      value={wordPressDetails?.api_key}
                      className="resize-none px-[20px] pr-[80px] rounded-[20px] w-full shadow-md border border-[#E9EBF0]"
                      // placeholder="Type something..."
                      disabled
                    ></textarea>

                    <button
                      data-tooltip-id="my-tooltip"
                      data-tooltip-content={tooltip}
                      type="button"
                      onClick={() => handleCopy("key")}
                      onMouseEnter={() => {
                        setShowTooltip(true);
                        settooltipType("key");
                      }}
                      onMouseLeave={() => {
                        setShowTooltip(false);
                        settooltipType("");
                        setTooltip("Copy");
                      }}
                      className="p-0 m-0 text-[28px] absolute right-[20px] top-[16%] transition-transform duration-200 active:scale-90"
                    >
                      {/* Tooltip */}
                      {/* Tooltip (Always visible when clicked, otherwise hidden) */}
                      {tooltipType === "key" && showTooltip && (
                        <div className="absolute bottom-full right-1/2 translate-x-1/2 mb-2 px-2 py-1 text-sm bg-gray-800 text-white rounded shadow-md ">
                          {tooltip}

                          {/* Tooltip arrow (V-shape) */}
                          <div className="absolute left-1/2 -bottom-2 -translate-x-1/2 w-0 h-0 border-l-8 border-l-transparent border-r-8 border-r-transparent border-t-8 border-t-gray-800"></div>
                        </div>
                      )}

                      <svg className="icon group relative">
                        <use href="#icon_copy"></use>
                      </svg>
                    </button>
                  </div>
                </div>
              </div>

              <div className="py-3 mt-4">
                <div>
                  <div className="flex items-center mb-3">
                    <h3 className="text-[22px] font-[700]">
                      Get Pixel For Above Website
                    </h3>
                    {/* <button
                      type="button"
                      className="ms-auto bg-gradient-to-r from-[#5E78F4] to-[#F14CE2] inline-block text-transparent bg-clip-text font-[600] text-[20px]"
                    >
                      Click To Generate
                    </button> */}
                  </div>
                  <div className="relative">
                    <textarea
                      ref={textareaRefPixel}
                      className="resize-none px-[20px] pr-[80px] rounded-[20px] w-full shadow-md border border-[#E9EBF0]"
                      disabled
                      value={
                        Object.keys(wordPressDetails || {})?.length > 0
                          ? `${process.env.REACT_APP_PIXEL_SCRIPT}?id=vsn-${
                              JSON.parse(localStorage.getItem("login_data"))
                                ?.resp_user?.id
                            }`
                          : ""
                      }
                    ></textarea>
                    <button
                      type="button"
                      className="p-0 m-0 text-[28px] absolute right-[20px] top-[16%] transition-transform duration-200 active:scale-90"
                      onClick={() => handleCopy("pixel")}
                      onMouseEnter={(e) => {
                        e.stopPropagation();
                        setShowTooltip(true);
                        settooltipType("pixel");
                      }}
                      onMouseLeave={(e) => {
                        e.stopPropagation();
                        setShowTooltip(false);
                        settooltipType("");
                        setTooltip("Copy");
                      }}
                    >
                      {tooltipType === "pixel" && showTooltip && (
                        <div className="absolute bottom-full right-1/2 translate-x-1/2 mb-2 px-2 py-1 text-sm bg-gray-800 text-white rounded shadow-md ">
                          {tooltip}

                          {/* Tooltip arrow (V-shape) */}
                          <div className="absolute left-1/2 -bottom-2 -translate-x-1/2 w-0 h-0 border-l-8 border-l-transparent border-r-8 border-r-transparent border-t-8 border-t-gray-800"></div>
                        </div>
                      )}

                      <svg className="icon group relative">
                        <use href="#icon_copy"></use>
                      </svg>
                    </button>
                  </div>
                </div>
              </div>

              {/* <div className="flex">
                <button
                  type="button"
                  className="ms-auto px-5 py-1 text-center rounded-[20px] text-[18px] font-semibold ring-[1px] ring-[#2A2A2A] ring-[none] hover:ring-[none] bg-gradient-to-r from-[#5E78F4] to-[#F14CE2] text-white hover:transition hover:delay-75"
                >
                  Test Pixel
                </button>
              </div> */}
            </div>
          </div>
        </Drawer.Items>
      </Drawer>
      <Drawer
        open={isOpenGSC}
        onClose={() => setIsOpenGSC(false)}
        position="right"
        className="p-0 w-[42%] notification-canvas add-canvas"
      >
        {/* <Drawer.Header title="Notification" className="pt-3 bg-[#D9F4FF]">kkkk</Drawer.Header> */}
        <div className="px-[28px] py-3 bg-[#D9F4FF] flex">
          <div className="flex items-center">
            <div className="w-[50px] h-[50px] me-4">
              <img src="images/gsc.svg" alt="..." className="w-full h-full" />
            </div>
            <div className="text-[16px] font-[500]">Google Search Console</div>
          </div>
          <button
            type="button"
            className="ms-auto"
            onClick={() => setIsOpenGSC(false)}
          >
            <svg className="icon text-[28px]">
              <use href="#icon_close"></use>
            </svg>
          </button>
        </div>
        <Drawer.Items className="">
          <div className="px-[28px] flex">
            {/* <div className="w-[60%]">
              <h5 className="py-3 mt-3">
                Benefits Of Integrating Google Serach Console
              </h5>
              <h5 className="py-3 mt-3">Integrate Google Search Console</h5>
              <p className="pb-4">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean
                fringilla placerat libero, viverra facilisis mi lobortis vita
                enim congue lacinia vulputate, diam ex faucibus felis, id
                sollicitudin urna orci eget nunc. Etiam malesuada tincidunt
                ipsum non tristique. Lorem ipsum dolor sit amet, consectetur
                adipiscing elit. Aenean fringilla placerat libero, viverra
                facilisis mi lobortis vita enim congue lacinia vulputate, diam
                ex faucibus felis, id sollicitudin urna orci eget nunc. Etiam
                malesuada tincidunt ipsum non tristique.
              </p>

              <p className="pb-4">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean
                fringilla placerat libero, viverra facilisis mi lobortis vita
                enim congue lacinia vulputate, diam ex faucibus felis, id
                sollicitudin urna orci eget nunc. Etiam malesuada tincidunt
                ipsum non tristique. Lorem ipsum dolor sit amet, consectetur
                adipiscing elit. Aenean fringilla placerat libero, viverra
                facilisis mi lobortis vita enim congue lacinia vulputate, diam
                ex faucibus felis, id sollicitudin urna orci eget nunc. Etiam
                malesuada tincidunt ipsum non tristique.
              </p>

              <ul>
                <li>
                  Lorem ipsum dolor sit amet consectetur adipisicing elit.
                  Officiis fugit dolore.
                </li>
                <li>
                  Lorem ipsum dolor sit amet consectetur adipisicing elit.
                  Officiis fugit dolore.
                </li>
                <li>
                  Lorem ipsum dolor sit amet consectetur adipisicing elit.
                  Officiis fugit dolore.
                </li>
                <li>
                  Lorem ipsum dolor sit amet consectetur adipisicing elit.
                  Officiis fugit dolore.
                </li>
              </ul>
            </div> */}
            <div className="w-full px-5">
              <div className="mt-6">
                <div className="flex items-center mb-3">
                  <h3 className="text-[22px] font-[700]">
                    Connect the website where you will be publishing Mark's
                    generated content, so Mark can analyze the performance
                  </h3>
                </div>
                <div className="flex">
                  <div className="w-full me-3">
                    <input
                      type="text"
                      placeholder="https://www.abc.com"
                      value={inputUrlGSC}
                      onChange={handleChangeGSC}
                      className="resize-none px-[20px] rounded-[14px] w-full shadow-md border border-[#E9EBF0]"
                      onKeyDown={(e) => {
                        if (e.key === "Enter") {
                          e.preventDefault();
                        }
                      }}
                    />
                  </div>
                  <button
                    type="button"
                    disabled={!isValidGSC || gscLoading || gsc_website}
                    // onClick={() => {
                    //   localStorage.setItem('gsc_website', inputUrlGSC);
                    //   gsc_website = inputUrlGSC;
                    // }}
                    onClick={() => getGSCAuth(inputUrlGSC)}
                    className={`py-2 max-w-[120px] w-full flex justify-center items-center text-center rounded-[20px] text-[18px] font-semibold ring-[1px] ring-[#2A2A2A] ring-[none] bg-gradient-to-r from-[#5E78F4] to-[#F14CE2] text-white hover:transition hover:delay-75 
                      ${
                        !isValidGSC || gscLoading || gsc_website
                          ? "opacity-80 cursor-not-allowed"
                          : ""
                      }`}
                  >
                    {gscLoading ? <Loader /> : "Add"}
                  </button>
                </div>
                {!isValidGSC && (
                  <p className="text-red-500 pt-2">Please enter a valid URL.</p>
                )}

                <div className="mt-4">
                  <div className="mt-4">
                    {[gsc_website].map((url, index) => (
                      <div
                        key={index}
                        className="flex items-center justify- mb-2 p-2  rounded-md"
                      >
                        <a
                          href={url}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="text-[#5E78F4] font-[600] text-[18px] truncate max-w-[85%]"
                        >
                          {url}
                        </a>

                        {/* Delete Button */}
                        {/* <button
                          onClick={() => deleteWordPressAuth()}
                          className="ml-2 text-red-500 hover:text-red-700 flex justify-center items-center"
                        >
                          {deleteUrl ? (
                            <Loader />
                          ) : (
                            <svg className="icon w-6 h-6">
                              <use href="#icon_delete"></use>
                            </svg>
                          )}
                        </button> */}
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Drawer.Items>
      </Drawer>
      <Drawer
        open={isOpenNotion}
        onClose={() => setIsOpenNotion(false)}
        position="right"
        className="p-0 w-[42%] notification-canvas add-canvas"
      >
        {/* <Drawer.Header title="Notification" className="pt-3 bg-[#D9F4FF]">kkkk</Drawer.Header> */}
        <div className="px-[28px] py-3 bg-[#D9F4FF] flex">
          <div className="flex items-center">
            <div className="w-[50px] h-[50px] me-4">
              <img
                src="images/icons8-notion.svg"
                alt="..."
                className="w-full h-full"
              />
            </div>
            <div className="text-[16px] font-[500]">Notion</div>
          </div>
          <button
            type="button"
            className="ms-auto"
            onClick={() => setIsOpenNotion(false)}
          >
            <svg className="icon text-[28px]">
              <use href="#icon_close"></use>
            </svg>
          </button>
        </div>
        <Drawer.Items className="">
          <div className="px-[28px] flex">
            {/* <div className="w-[60%]">
              <h5 className="py-3 mt-3">Benefits Of Integrating Notion</h5>
              <h5 className="py-3 mt-3">Integrate Notion</h5>
              <p className="pb-4">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean
                fringilla placerat libero, viverra facilisis mi lobortis vita
                enim congue lacinia vulputate, diam ex faucibus felis, id
                sollicitudin urna orci eget nunc. Etiam malesuada tincidunt
                ipsum non tristique. Lorem ipsum dolor sit amet, consectetur
                adipiscing elit. Aenean fringilla placerat libero, viverra
                facilisis mi lobortis vita enim congue lacinia vulputate, diam
                ex faucibus felis, id sollicitudin urna orci eget nunc. Etiam
                malesuada tincidunt ipsum non tristique.
              </p>

              <p className="pb-4">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean
                fringilla placerat libero, viverra facilisis mi lobortis vita
                enim congue lacinia vulputate, diam ex faucibus felis, id
                sollicitudin urna orci eget nunc. Etiam malesuada tincidunt
                ipsum non tristique. Lorem ipsum dolor sit amet, consectetur
                adipiscing elit. Aenean fringilla placerat libero, viverra
                facilisis mi lobortis vita enim congue lacinia vulputate, diam
                ex faucibus felis, id sollicitudin urna orci eget nunc. Etiam
                malesuada tincidunt ipsum non tristique.
              </p>

              <ul>
                <li>
                  Lorem ipsum dolor sit amet consectetur adipisicing elit.
                  Officiis fugit dolore.
                </li>
                <li>
                  Lorem ipsum dolor sit amet consectetur adipisicing elit.
                  Officiis fugit dolore.
                </li>
                <li>
                  Lorem ipsum dolor sit amet consectetur adipisicing elit.
                  Officiis fugit dolore.
                </li>
                <li>
                  Lorem ipsum dolor sit amet consectetur adipisicing elit.
                  Officiis fugit dolore.
                </li>
              </ul>
            </div> */}
            <div className="w-full px-5">
              <div className="mt-6">
                <div className="flex items-center mb-3">
                  <h3 className="text-[22px] font-[700]">
                    Connect to your Notion pages
                  </h3>
                </div>
                <div className="flex">
                  {/* <div className="w-full me-3">
                    <input
                      type="text"
                      placeholder="https://www.abc.com"
                      value={inputUrlGSC}
                      onChange={handleChangeGSC}
                      className="resize-none px-[20px] rounded-[14px] w-full shadow-md border border-[#E9EBF0]"
                      onKeyDown={(e) => {
                        if (e.key === "Enter") {
                          e.preventDefault();
                        }
                      }}
                    />
                  </div> */}
                  <button
                    type="button"
                    disabled={!isValidNotion || notionLoading}
                    // onClick={() => {
                    //   localStorage.setItem('gsc_website', inputUrlGSC);
                    //   gsc_website = inputUrlGSC;
                    // }}
                    onClick={() =>
                      getNotionAuth(
                        true
                        //for now sending bool instead of text
                      )
                    }
                    className={`py-2 max-w-[120px] w-full flex justify-center items-center text-center rounded-[20px] text-[18px] font-semibold ring-[1px] ring-[#2A2A2A] ring-[none] bg-gradient-to-r from-[#5E78F4] to-[#F14CE2] text-white hover:transition hover:delay-75 
                      ${
                        !isValidNotion || notionLoading
                          ? "opacity-80 cursor-not-allowed"
                          : ""
                      }`}
                  >
                    {notionLoading ? (
                      <Loader />
                    ) : !notion_access ? (
                      "Connect"
                    ) : (
                      "Reconnect"
                    )}
                  </button>
                </div>
                {/* {!isValidGSC && (
                  <p className="text-red-500 pt-2">Please enter a valid URL.</p>
                )} */}

                {notionAccessList?.length > 0 && (
                  <div className="mt-4">
                    Connected Notion Pages
                    <div className="mt-4">
                      {notionAccessList
                        .filter((page) => !page.parent_id)
                        .map((parentPage, indexP) => (
                          <div key={parentPage.id} className="mb-2">
                            <div className="flex items-center">
                              <a
                                href={parentPage.public_url || parentPage.url}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="ml-2 text-gray-500 hover:text-gray-700"
                              >
                                {indexP + 1}) {parentPage.title}
                              </a>
                            </div>
                            <div className="ml-6">
                              {notionAccessList
                                .filter(
                                  (childPage) =>
                                    childPage.parent_id === parentPage.page_id
                                )
                                .map((childPage) => (
                                  <div
                                    key={childPage.id}
                                    className="flex items-center mt-1"
                                  >
                                    <a
                                      href={
                                        childPage.public_url || childPage.url
                                      }
                                      target="_blank"
                                      rel="noopener noreferrer"
                                      className="ml-2 text-gray-500 hover:text-gray-700"
                                    >
                                      • {childPage.title}
                                    </a>
                                  </div>
                                ))}
                            </div>
                            <hr className="ms-6 mt-2" />
                          </div>
                        ))}
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </Drawer.Items>
      </Drawer>
      <FailureModal
        open={openFailureModal}
        removeModal={removeModal}
        successFailureMessage={successFailureMessage}
      />
      <SuccessModal
        open={openSuccessModal}
        removeModal={removeModal}
        successFailureMessage={successFailureMessage}
      />
      {/* <Tooltip id="my-tooltip" /> */}
    </>
  );
}

export default IntegrationMarketing;
